import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of categories
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to categories
   */
  getAll(params) {
    return backofficeService.Api().get('crm/api/promotion', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getByStoreId(id, params) {
    return backofficeService.Api().get(`crm/api/promotion/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getSettlementById(id) {
    console.log('running this')
    return backofficeService.Api().get(`cspApi/sms/settlementByID/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
